import React, { useMemo } from 'react'
import { highlightValue } from '../../../helpers/highlightHelper'
import { SearchableValue } from '../../../helpers/searchHelper'
import { HighlightedText } from './HighlightedText'

type HighlightedValueProps = {
   value: SearchableValue
   /** Already normalized. Absent outside search. */
   query?: string
   maxLength?: number
}

/** Falls back to the plain value without a query, so the same cell serves list and search results. */
export const HighlightedValue = ({ value, query, maxLength }: HighlightedValueProps): JSX.Element => {
   const segments = useMemo(() => (query ? highlightValue(value, query, maxLength) : null), [value, query, maxLength])

   if (segments) return <HighlightedText segments={segments} />

   const plain = value === null || value === undefined ? '' : value.toString()
   return <>{maxLength && plain.length > maxLength ? `${plain.slice(0, maxLength)}…` : plain}</>
}
